<template>
    <v-app id="us-join-company">
        <v-app-bar color="blue-grey" dense dark app>
            <v-btn icon @click="goHome">
                <v-icon style="font-size:2rem;">mdi-chevron-left</v-icon>
            </v-btn>
            <v-toolbar-title style="font-size:1rem;">绑定设备确认</v-toolbar-title>
            <v-spacer></v-spacer>
        </v-app-bar>
        <v-content style="padding-top:1rem;">
            <v-container style="margin-top:5.5rem;">
                <div style="text-align:center;">
                  <!-- <i style="font-size:10rem;color:#03A9F4;" class="fa fa-share-alt-square" aria-hidden="true" /> -->
                  <!-- <img width="160" height="160" src="/res/favicon.png"/> -->
                  <!-- <img width="160" height="160" src="/res/icon/fav/favicon-128.png"/> -->
                  <img width="160" height="160" src="/res_ext/icon/fav/favicon-128.png"/>
                </div>
                <div style="text-align:center;margin-top:1rem;font-weight: bold;">
                  <div v-if="inivteState === 400 || inivteState === 401" style="color:#F56C6C;font-size:22px;">
                      二维码无效.
                  </div>
                  <div v-else-if="inivteState === 402" style="color:#606266;font-size:22px;">
                      二维码过期了.
                  </div>
                  <div v-else-if="inivteState === 403" style="color:#606266;font-size:22px;">
                      设备已经被绑定了.
                  </div>
                  <div v-else-if="inivteState === 200">
                    <div style="color:#606266;font-size:22px;">确定绑定这个设备吗？</div>
                    <v-divider style="margin: 20px 0 8px;"></v-divider>
                    <div>
                      <v-row style="width:80%;margin:auto;">
                          <v-col :cols="12" style="color:#9e9e9e;font-size:18px;padding-right:5px;text-align:left;">选择绑定团队</v-col>
                          <v-col :cols="12" style="position:relative;font-size:18px;text-align:left;border: 1px solid #eee;">
                              <select id="us-select" style="outline:none;text-overflow: ellipsis;white-space: nowrap;width: 100%;padding-right: 30px" placeholder="请选择" v-model="selectCode" @change="btnDisabled = false" >
                                <option :value="item.code" v-for="(item,index) in myCompanyList" :key="index">
                                  <span>{{item.name}}</span>
                                </option>
                              </select>
                              <i class="fa fa-angle-down" aria-hidden="true" style="font-size:1.2rem;color:#808080;position:absolute;right:1rem;pointer-events:none;" ></i>
                          </v-col>
                      </v-row>
                    </div>
                    <div style="margin:auto;margin-top:1rem;text-align:center;">
                      <!-- <div><v-btn large color="success" style="width:60%;font-weight:bold;font-size:0.96rem;" @click="onSubmit" :disabled="btnDisabled" >确定</v-btn></div>
                      <div><v-btn large color="#f2f2f2" style="width:60%;margin-top:2rem;font-weight:bold;font-size:0.96rem;" @click="onCancel" :disabled="btnDisabled" >取消</v-btn></div> -->
                      <div>
                        <v-btn large class="secondary us-btn-style" @click="onSubmit" :disabled="btnDisabled" >确定</v-btn>
                      </div>
                      <div>
                        <v-btn large color="#f5f5f5" class="us-btn-style" @click="onCancel">
                          <span style="color: #959595;">取消</span>
                        </v-btn>
                      </div>
                    </div>
                  </div>
                  <div v-else style="color:#606266;font-size:22px;">[{{inivteState}}]</div>
                  <div v-if="inivteState !== 200" class="text-center">
                    <v-btn
                      color="blue-grey"
                      class="white--text us-btn-style"
                      large
                      @click="goHome"
                    >
                      返回主页
                    </v-btn>
                  </div>
                </div>
            </v-container>
        </v-content>
    </v-app>

</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      btnDisabled: false,
      inivteState: 0,
      strRes: '',
      shareRecord: {},
      shareCode: '',
      prodKey: '',
      devName: '',
      myCompanyList: [],
      selectCode: '',
      oldSelectCode: ''
    }
  },
  computed: {
  },
  mounted() {
    var that = this
    that.shareCode = that.$route.query.share_code;
    // console.log('that.shareCode', that.shareCode);
    that.getShareRecord()
  },
  created() {
  },
  methods: {
    goHome() {
      var that = this;
      that.$router.replace('/Home')
    },
    async getShareRecord() {
      var that = this
      if (!that.shareCode || that.shareCode === '') {
        that.inivteState = 400
        return
      }
      var res = await that.$api.bz.getShareRecord({ code: that.shareCode })
      that.strRes = JSON.stringify(res)
      // console.log('getShareRecord.res', res);
      if (!res.success) {
        that.getFormatState(res.error_msg)
        return
      }
      that.shareRecord = res.data
      // 获取分享参数
      var shareParams = JSON.parse(that.shareRecord.SHARE_PARAMS)
      that.prodKey = shareParams.prod_key;
      that.devName = shareParams.dev_name;
      // console.log('that.prodKey', that.prodKey);
      // console.log('that.devName', that.devName);
      // 如果设备绑定码没过期、则检查设备绑定状态
      that.checkBindState()
    },
    async onSubmit() {
      var that = this
      if (that.selectCode === '') {
        that.$toast.warning('请选择公司团队');
        return
      }
      var res = await that.$api.iot.bindGatewayDevice({ prod_key: that.prodKey, dev_name: that.devName, company_code: that.selectCode })
      // console.log('bindGatewayDevice.res', res);
      if (!res.success) {
        that.$toast.warning(res.error_msg);
        return
      }

      if (that.selectCode !== that.oldSelectCode) {
        await that.$AppHelper.pullUserCustomData();
        await that.$AppHelper.pullNewUserToken();
      }

      that.btnDisabled = true
      that.$router.goActionResPage({ tag: 1, text: '绑定成功', auto_ret: 'a' })
    },
    getFormatState(errMsg) {
      var that = this
      var errCode = errMsg.substr(1, 3)
      if (errCode === '401') {
        that.inivteState = 401
      } else if (errCode === '402') {
        that.inivteState = 402
      } else if (errCode === '403') {
        that.inivteState = 403
      } else {
        that.inivteState = 400
      }
    },
    onCancel() {
      var that = this
      that.btnDisabled = true
      that.$router.goActionResPage({ tag: 0, text: '已拒绝', auto_ret: 'a' })
    },
    // 检查设备绑定状态
    async checkBindState() {
      var that = this
      var res = await that.$api.iot.checkGatewayBindState({ prod_key: that.prodKey, dev_name: that.devName })
      if (!res.success) {
        console.log('检查设备绑定状态失败', res);
        return
      }
      var data = res.data
      if (data.state !== 0) {
        that.inivteState = 403
        that.btnDisabled = true
        return
      }
      that.inivteState = 200
      that.getMyCompanyList()
    },
    // 获取用户管理的公司列表
    async getMyCompanyList() {
      var that = this
      var res = await that.$api.bz.getUserCompanyList()
      // console.log('getUserCompanyList.res', res);
      if (!res.success) {
        console.log('获取用户管理的公司列表失败', res);
        return
      }
      var data = res.data
      that.myCompanyList = data
      if (!data || data.length === 0) {
        that.selectCode = ''
        that.btnDisabled = true
        return;
      }

      var staffInfo = that.$AppHelper.getCustomData('staff_info');
      // console.log('staffInfo', staffInfo);
      var codeData = data.filter((i) => {
        return staffInfo.COMPANY_CODE == i.code;
      });

      if (!codeData || codeData.length === 0) {
        that.selectCode = ''
        that.oldSelectCode = staffInfo.COMPANY_CODE
        that.btnDisabled = true
        return;
      }

      that.selectCode = staffInfo.COMPANY_CODE
      that.oldSelectCode = staffInfo.COMPANY_CODE
      that.btnDisabled = false
    },
    clickSelect() {
      var e = window.document.getElementById('us-select');
      console.log('eee', e);
    }
    // open(elem) {
    //   if (document.createEvent) {
    //     var e = document.createEvent('MouseEvents');
    //     e.initMouseEvent('mousedown', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
    //     elem[0].dispatchEvent(e);
    //   } else if (element.fireEvent) {
    //     elem[0].fireEvent('onmousedown');
    //   }
    // }
  }
}
</script>

<style scoped>
.secondary {
    background-color: #5cbbf6 !important;
    border-color: #5cbbf6 !important;
}
.us-btn-style {
  font-size: 16px;
  width: 90%;
  font-weight: bold;
  margin-top: 1.1rem;
  text-align: center;
}
</style>
